import type { ClientErrorStatusCode } from 'hono/utils/http-status'

// Keep the backend status when a query turns an API result into a rejected promise.
export class ApiRequestError extends Error {
    readonly httpStatus?: number

    constructor(result: { message?: string; httpStatus?: number }) {
        super(result.message || `HTTP ${result.httpStatus}`)
        this.name = 'ApiRequestError'
        this.httpStatus = result.httpStatus
    }
}

export function getApiErrorStatus(error: unknown): ClientErrorStatusCode | 500 {
    const status = error instanceof ApiRequestError ? error.httpStatus : undefined
    if (typeof status === 'number' && Number.isInteger(status) && status >= 400 && status < 500) {
        return status as ClientErrorStatusCode
    }
    return 500
}
